import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { FornitoreAccesso } from './auth/ContestoAccesso';
import { rotte } from './router/rotte';
import './stili/index.css';

const radice = document.getElementById('root');
if (!radice) throw new Error('Manca #root in index.html');

/* L'autenticazione avvolge il router e non il contrario: il router deve poter
   leggere la sessione già al primo render, altrimenti il cancello rimanda al
   login anche quando il token è in archivio. */
createRoot(radice).render(
  <StrictMode>
    <FornitoreAccesso>
      <RouterProvider router={rotte} />
    </FornitoreAccesso>
  </StrictMode>,
);
